module.exports = __webpack_public_path__ + "static/media/toothbrush.64d6db1e.svg";